const UserCircle = ({ width, height = 'h-auto' }) => {
    return (
        <div className={`user-circle-icon ${width} ${height}`}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 21 21"
                className={`${width} ${height}`}
            >
                <path
                    stroke="#231F20"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.25"
                    d="M10.324 18a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15"
                ></path>
                <path
                    stroke="#231F20"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.25"
                    d="M10.324 13a3.125 3.125 0 1 0 0-6.25 3.125 3.125 0 0 0 0 6.25"
                ></path>
                <path
                    stroke="#231F20"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.25"
                    d="M5.309 16.075a5.625 5.625 0 0 1 10.03 0"
                ></path>
            </svg>
        </div>
    )
}

export default UserCircle
